import React, { useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { setShowPopupScheduleFilters } from '../../../../store/slices/modalSlice'
import { type RootState } from '../../../../store/store'

import './ScheduleFiltersDesktop.scss'

interface ScheduleFiltersDesktopProps {
  children: React.ReactNode
  title: string
}

export default function ScheduleFiltersDesktop({ children }: ScheduleFiltersDesktopProps) {
  const showPopupScheduleFilters = useAppSelector((state: RootState) => state.modal.showPopupScheduleFilters)
  const dispatch = useAppDispatch()

  const onClose = () => {
    dispatch(setShowPopupScheduleFilters(false))
  }

  useEffect(() => {
    if (!showPopupScheduleFilters) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [showPopupScheduleFilters, onClose])

  const container = useMemo(() => (typeof document !== 'undefined' ? document.body : null), [])

  if (!showPopupScheduleFilters || !container) return null

  return createPortal(
    <div className="schedule-filters-desktop-overlay" onClick={onClose}>
      <div
        className="schedule-filters-desktop-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    container
  )
}
